import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import addUrlHostName from '../../utils/addUrlHostname';
import IconComponent from '../Icon';
import MenuItem from '../../data/MenuItem';
import useFlyoutThemes from './themes';
import DropdownMenu from './DropdownMenu';
import MegaMenu from './MegaMenu';
import SuperMenu from './SuperMenu';

import { FlyoutType } from './_props';

function Flyout({
  menuItems,
  selectedLabel = '',
  iconProps,
  superMenu = false,
  bg = 'Light',
  size = 'Medium',
  itemClasses,
  selectedItemClasses = '',
}: FlyoutType) {
  const {
    flyoutUlClasses,
    flyoutLiClasses,
    flyoutSizesLiClasses,
    flyoutSelectedClasses,
    flyoutMainLinkClasses,
    flyoutSelectedActiveClasses,
    flyoutSelectedNotActiveClasses,
    flyoutLiSize,
    flyoutIconProps,
    flyoutSubLiCenter,
    flyoutSubLiEnd,
  } = useFlyoutThemes({ bg, size });

  const SubMenu = superMenu ? SuperMenu : DropdownMenu;
  return (
    <ul className={flyoutUlClasses}>
      {menuItems.map((item: MenuItem, index) => (
        <li
          key={item.id}
          className={twMerge(
            `group ${item.id === 'megamenTempID' ? 'static' : 'relative'}`,
            flyoutLiClasses,
            flyoutSizesLiClasses,
            flyoutSelectedClasses,
            flyoutLiSize,
            {
              [flyoutSelectedActiveClasses]: selectedLabel && item.label === selectedLabel,
              [flyoutSelectedNotActiveClasses]: !selectedLabel || item.label !== selectedLabel,
              [flyoutSubLiEnd]: index === menuItems.length - 1,
              [flyoutSubLiCenter]: index !== menuItems.length - 1,
              [selectedItemClasses]: selectedLabel && item.label === selectedLabel,
            },
            itemClasses,
          )}
        >
          <a href={`${addUrlHostName(item.path)}?nav=old`} className={flyoutMainLinkClasses}>
            {item.label}
            {item.children.length > 0 && (
              <IconComponent iconName="ExpandMore" {...flyoutIconProps} {...iconProps} />
            )}
          </a>
          {item.children.length > 0 &&
            (item.id === 'megamenTempID' ? <MegaMenu subMenuItem={item} /> : <SubMenu subMenuItem={item} />)}
        </li>
      ))}
    </ul>
  );
}

export { type FlyoutType };

export default Flyout;
